











































































import Vue from "vue";
import Component from "vue-class-component";
import VueTimepicker from "vuejs-timepicker";
import fieldData from "@/ts/FormData";
import func from "@/ts/FormFunctions";
import ErrorMessages from "@/ts/constants/PermitsErrorMessages";
import { IPermitVueModel } from '@/ts/models/IPermitVueModel';
import builder, { IVueStateCollection } from "@/ts/FormBuilder";
import { IOperatingHoursVueModel } from '@/ts/models/IOperatingHoursVueModel';

@Component({
    props: {
        form: {
            type: Object as () => IPermitVueModel
        },
        vueStates: {
            type: Object as () => IVueStateCollection
        },
        isReadOnly: {
            type: Boolean
        }
    },
    components: {
        VueTimepicker
    }
})
export default class OperatingHours extends Vue {
    name: string = "OperatingHours";
    title: string = "";
    index: number = NaN;

    errorMsgs = ErrorMessages;
    
    mounted(): void {
        this.initializeComponent(this.name);

        if (this.$props.form.operatingHours.length === 0) {
            this.$props.form.operatingHours = fieldData.operatingHours;
        }
    }

    private initializeComponent(routeName: string): void {
        this.index = builder.getIndexByVueState(this.$props.vueStates.views, routeName);
        this.title = this.$props.vueStates.views[this.index].name;

        this.$emit("update:title", this.title);
        this.$emit("update:currentIndex", this.index);

        this.$watch("hasErrors", (n, o) => {
            this.$props.vueStates.views[this.index].error = this.hasErrors;
        }, { immediate: true });

        this.$props.vueStates.views[this.index].visited = true;
    }

    checkChanged(index: number): void {
        let isChecked: boolean = this.$props.form.operatingHours[index].isOpen;
        if (isChecked) {
            this.$props.form.operatingHours[index].from = { h: "1", mm: "00", a: "am" };
            this.$props.form.operatingHours[index].to = { h: "1", mm: "00", a: "pm" };
        } else {
            this.$props.form.operatingHours[index].from = { h: "", mm: "", a: "" };
            this.$props.form.operatingHours[index].to = { h: "", mm: "", a: "" };
        }
    }

    isTimeError(isOpen: boolean, time: any): boolean {
        if (isOpen) {
            return func.isNullOrEmpty(time.h) || func.isNullOrEmpty(time.mm) || func.isNullOrEmpty(time.a);
        }
        return false;
    }

    get isNoHoursSelected(): boolean {
        return !(this.$props.form.operatingHours as IOperatingHoursVueModel[]).some((oh, ix, arr) => oh.isOpen);
    }

    get isOperatingHoursError(): boolean {
        return (this.$props.form.operatingHours as IOperatingHoursVueModel[]).some((oh, ix, arr) => {
            return this.isTimeError(oh.isOpen, oh.from) || this.isTimeError(oh.isOpen, oh.to);
        });
    }

    get hasErrors(): boolean {
        return this.isNoHoursSelected || this.isOperatingHoursError;
    }
}
